export default "__VITE_ASSET__WT5XeqbW__"